import "./lang-switcher";
import "./mobile-menu";
import "./nav-dropdown";
import "./sticky-header";
import initSearch from "./search";

initSearch();
